<template>
  <div>
    <div v-if="!isMobile" class="q-pa-lg rounded-borders-lg bg-primary q-mx-md">
      <div class="row scroll no-wrap">
        <SAIQuoteCard
          v-for="(quote, index) in quotes"
          :loading="quotesLoading[quote.quoteId]"
          :error="quotesErrors[quote.quoteId]"
          :error-contact-number="orgContactPhone"
          :error-img="errorImg"
          :key="index"
          :class="index ? 'q-ml-md' : undefined"
          width="364px"
          :tag="getQuoteTagDetails(quote.status).label"
          :tag-color="getQuoteTagDetails(quote.status).color"
          :kms-per-year="quote.kmsPerYear"
          :lease-term="quote.leaseTerm"
          :next-text="
            completedQuote === quote.quoteId ? 'Check Progress' : undefined
          "
          :disable="!quoteHasSummary(quote)"
          :cost="getQuoteCost(quote)"
          :cost-from-frequency="
            $Constants.CALCULATION_FREQUENCIES.monthly.value
          "
          :cost-to-frequency="$Constants.CALCULATION_FREQUENCIES.weekly.value"
          :img="
            quote.variant.photos.length
              ? quote.variant.photos[0].path
              : undefined
          "
          :title="`${
            isMiles(quote)
              ? quote.variant.name
              : `${quote.make.description} ${quote.model.name} ${quote.variant.name}`
          }`"
          :reference="`${
            isMiles(quote)
              ? `${quote.milesQuoteRef}/${quote.quoteRevisionNumber}`
              : quote.erpQuoteRef
          }`"
          @click="$emit('open', quote)"
        />
      </div>
    </div>
    <QCarousel
      v-model="carouselId"
      swipeable
      animated
      infinite
      vertical
      v-else
      class="bg-primary"
      style="height: initial"
    >
      <QCarouselSlide
        :name="index"
        v-for="(quote, index) in quotes"
        :key="index"
      >
        <SAIQuoteCard
          class="full-width"
          :loading="quotesLoading[quote.quoteId]"
          :error="quotesErrors[quote.quoteId]"
          :error-contact-number="orgContactPhone"
          :error-img="errorImg"
          :tag="getQuoteTagDetails(quote.status).label"
          :tag-color="getQuoteTagDetails(quote.status).color"
          :kms-per-year="quote.kmsPerYear"
          :lease-term="quote.leaseTerm"
          :next-text="
            completedQuote === quote.quoteId ? 'Check Progress' : undefined
          "
          :disable="!quoteHasSummary(quote)"
          :cost="getQuoteCost(quote)"
          :cost-from-frequency="
            $Constants.CALCULATION_FREQUENCIES.monthly.value
          "
          :cost-to-frequency="$Constants.CALCULATION_FREQUENCIES.weekly.value"
          :img="
            quote.variant.photos.length
              ? quote.variant.photos[0].path
              : undefined
          "
          :title="`${
            isMiles(quote)
              ? quote.variant.name
              : `${quote.make.description} ${quote.model.name} ${quote.variant.name}`
          }`"
          :reference="`${
            isMiles(quote)
              ? `${quote.milesQuoteRef}/${quote.quoteRevisionNumber}`
              : quote.erpQuoteRef
          }`"
          @click="$emit('open', quote)"
        />
      </QCarouselSlide>
    </QCarousel>
  </div>
</template>

<script>
import isMiles from '@/utils/is-miles';
import { SAIQuoteCard } from 'ecx.saigon.ui.common';
import { QCarousel, QCarouselSlide } from 'quasar';
import getQuoteTagDetails from '../../../utils/get-quote-tag-details';
import quoteHasSummary from '../../../utils/quote-has-summary';

export default {
  name: 'QuoteStepper',
  props: {
    isMobile: Boolean,
    completedQuote: String,
    orgContactPhone: String,
    errorImg: String,
    quotes: {
      type: Array,
      default: () => [],
    },
    quotesErrors: {
      type: Object,
      default: () => ({}),
    },
    quotesLoading: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      carouselId: 0,
    };
  },
  watch: {
    quotes(value = []) {
      if (!value || !value[this.carouselId]) {
        this.carouselId = 0;
      }
    },
  },
  methods: {
    quoteHasSummary,
    getQuoteTagDetails,
    getQuoteCost(quote) {
      const displayStatuses = [
        this.$Constants.QUOTE_STATUSES.PRICINGRECEIVED.value,
        this.$Constants.QUOTE_STATUSES.ACCEPTED.value,
      ];
      return displayStatuses.includes(quote.status)
        ? quote.novated.impactTakeHome
        : undefined;
    },
    isMiles,
  },
  components: {
    QCarousel,
    QCarouselSlide,
    SAIQuoteCard,
  },
};
</script>
